"use client";

import PrivacyPolicyView from "@/views/PrivacyPolicy";

export default function PrivacyPolicyPage() {
  return <PrivacyPolicyView />;
}
